<template>
  <div class="content animate-panel" id="content">
    <h2 class="m-n">プレミアム</h2>
    <div class="hpanel">
      <nav-tabs :data="premiumSubmenu" :currentTab="tab" />
      <tab-content :data="premiumSubmenu" :currentTab="tab" />
    </div>
  </div>
</template>
<script>
import NavTabs from './components/NavTabs.vue'
import TabContent from './components/TabContent.vue'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    NavTabs,
    TabContent
  },
  data () {
    return {
      loader: null,
      data: [],
      tab: null
    }
  },
  computed: {
    isBasicPlan () {
      return this.$store.getters.getUser.memberPlan === '0'
    },
    premiumSubmenu () {
      return this.$store.getters.getPremiumMenu
    }
  },
  created () {
    if (this.isBasicPlan) {
      this.$router.push('/not-found')
      return false
    }
    const currentTab = this.$route.params.tab
    this.tab = Number(currentTab)
  },
  methods: {
  },
  watch: {
    $route (to) {
      const toTab = to.params.tab
      this.tab = toTab
      if (this.tab) {
        let logParams = {
          name: eventCode.premium.show,
          properties: {
            id: this.tab
          }
        }
        EventService.postTrackLog(logParams)
      }
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/premium/Premium.vue